var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHairdryer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4747 3.03799C19.4086 2.67785 22 4.92436 22 7.8279V8.22733C22 10.8693 19.6771 12.9338 17 12.6709L16.2448 19.7161C16.1056 21.0144 14.9908 22 13.6614 22C11.872 22 10.6184 20.2649 11.2095 18.6063L13.0943 13.3183C13.3036 12.7308 12.9108 12.1027 12.2826 12.0205L6 11V4L16.4747 3.03799ZM17.5 10.2158C18.8807 10.2158 20 9.11669 20 7.76082C20 6.40494 18.8807 5.30578 17.5 5.30578C16.1193 5.30578 15 6.40494 15 7.76082C15 9.11669 16.1193 10.2158 17.5 10.2158ZM13.5 20.527C14.0523 20.527 14.5 20.0873 14.5 19.545C14.5 19.0026 14.0523 18.563 13.5 18.563C12.9477 18.563 12.5 19.0026 12.5 19.545C12.5 20.0873 12.9477 20.527 13.5 20.527Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.625L3.24254 3.31063C2.61139 3.15285 2 3.63021 2 4.28078V10.7192C2 11.3698 2.61139 11.8472 3.24254 11.6894L4.5 11.375V3.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairdryer);
export default __webpack_public_path__ + "static/media/hairdryer.65380488486ae507718902a62e6ef97e.svg";
export { ForwardRef as ReactComponent };